export const CONTACT_INFO_DEFAULT_METHOD = 'phone.label'
export const TEXT = 1
export const PHONE_NUMBER = 3
export const contactType = ['phone.label', 'crm.custom.field.email']

export const GENERAL = 1
export const CONTACT = 2
export const PHYSICAL_ADDRESS = 3
export const MAILING_ADDRESS = 4
export const SOCIAL_INFORMATION = 5
export const SHIPPING_ADDRESS = 7
export const BILLING_ADDRESS = 6

const INSTAGRAM = 'Instagram'
const GG = 'GG+'
const YOUTUBE = 'Youtube'
const OTHER = 'Other'

export const SOCIAL_PAGES = [INSTAGRAM, GG, YOUTUBE, OTHER]
export const DEFAULT_SOCIAL_PAGE = 'Instagram'

export const ADDRESSES = [
  'crm.custom.field.physical.address.name',
  'crm.custom.field.mailing.address.name',
  'crm.custom.field.shipping.address.name',
  'crm.custom.field.billing.address.name',
]
